var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _path14, _rect2, _rect3, _path15, _path16, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLgoGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st1 {\n        fill: #d47500;\n      }\n\n      .st2 {\n        stroke: #336;\n      }\n\n      .st2, .st3 {\n        fill: none;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 48px;\n      }\n\n      .st3 {\n        stroke: #d47500;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M477.6,249c0,40.3-32.7,72.9-73,72.9-40.3,0-72.9-32.7-72.9-72.9,0-40.3,32.7-72.9,72.9-72.9,19.4,0,37.9,7.7,51.6,21.4,13.7,13.7,21.4,32.2,21.3,51.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M479.9,429.4h-150.4c-52.5,1.7-94.3,44.7-94.3,97.3s41.7,95.6,94.3,97.3h150.4c52.5-1.7,94.3-44.7,94.3-97.3s-41.7-95.6-94.3-97.3h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M662,304.8c0,30.8-25,55.8-55.8,55.7-30.8,0-55.8-25-55.8-55.8,0-30.8,25-55.8,55.8-55.8s29,5.9,39.4,16.3c10.5,10.5,16.3,24.7,16.3,39.5h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M138.7,304.8c0,30.8,25,55.8,55.8,55.8s55.8-25,55.8-55.8-25-55.8-55.8-55.8-55.8,25-55.8,55.8h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M622,426.8c-13.3,0-24,10.7-24,24s10.7,24,24,24v-48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.8,450.8l.5-24c-.2,0-.3,0-.5,0v24Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.8,599.7v24c.2,0,.3,0,.5,0l-.5-24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M622,575.7c-13.3,0-24,10.7-24,24s10.7,24,24,24v-48Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.7,474.8c13.3,0,24-10.7,24-24s-10.7-24-24-24v48Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.9,450.8v-24c-.2,0-.3,0-.5,0l.5,24Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.9,599.7l-.5,24c.2,0,.3,0,.5,0v-24Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.7,623.7c13.3,0,24-10.7,24-24s-10.7-24-24-24v48Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 622,
    y: 426.8,
    width: 41.8,
    height: 48
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M663.3,474.8c27.4.6,49.4,23,49.4,50.4h48c0-53.6-42.8-97.3-96.4-98.4l-1,48Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M712.7,525.3c0,27.4-21.9,49.9-49.4,50.4l1,48c53.6-1.1,96.4-44.8,96.4-98.4h-48Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 622,
    y: 575.7,
    width: 41.8,
    height: 48
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 136.9,
    y: 426.8,
    width: 41.8,
    height: 48
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.4,426.9c-53.6,1.1-96.4,44.8-96.4,98.4h48c0-27.4,21.9-49.9,49.4-50.4l-1-48Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40,525.3c0,53.6,42.8,97.3,96.4,98.4l1-48c-27.4-.6-49.4-23-49.4-50.4h-48Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 136.9,
    y: 575.7,
    width: 41.8,
    height: 48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgoGroup);
export default __webpack_public_path__ + "static/media/LGO_Group.a24562416c85b425023ffa14c346e812.svg";
export { ForwardRef as ReactComponent };